import React from "react";
import RichText2 from "./WhatToseeRichText2";

export default function DrivingOptions(props) {
  return (
    <div>
      <div className="state-products drivingOptions">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6"></div>
            <div className="col-sm-6">
              <h1 className="title-mobile-text">
                { props?.DrivingOptions?.content?.Media_Object_Group[0]?.Heading }
              </h1>
            </div>
          </div>
          {props?.DrivingOptions?.content?.Media_Object_Group?.map((item) => {
            return (
              <>
                <div className="row">
                  {item.Image_Position === "left" ? (
                    <>
                      <div className="col-sm-6">
                        <img
                          alt={item?.Image?.alt}
                          src={item?.Image?.filename}
                          className="img-fluid"
                        />
                      </div>

                      <div className="col-sm-6">
                        <h1 className="title-desktop-text">{item?.Heading}</h1>

                        <>
                          <RichText2 Description={item.Description} />
                        </>
                      </div>
                    </>
                  ) : (
                    <div className="windy-city">
                    <div className="col-sm-6">
                        <h1>{item?.Heading}</h1>
                        <p>{<RichText2 Description={item.Description} />}</p>
                      </div>
                      <div className="col-sm-6">
                        <img
                          alt={item?.Image?.alt}
                          src={item?.Image?.filename}
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
}
